module.exports = __webpack_public_path__ + "img/Person_mit_Sonderfunktion.ba7a3439.svg";